import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Plus, Target } from "lucide-react";
import { Mission } from "@/types/todo";


interface MissionSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  missions: Mission[];
  onSelectMission: (missionId: string) => void;
  onCreateNew: () => void;
}

const MissionSelectionModal = ({ 
  isOpen, 
  onClose, 
  missions, 
  onSelectMission, 
  onCreateNew 
}: MissionSelectionModalProps) => {
  const handleSelectMission = (missionId: string) => {
    onSelectMission(missionId);
    onClose();
  };

  const handleCreateNew = () => {
    onCreateNew();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2">
            <Target className="text-primary" size={20} />
            Select Mission
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          {(() => {
            const availableMissions = missions.filter(mission => !mission.isCompleted);
            return availableMissions.length === 0 ? (
              <p className="text-muted-foreground text-sm text-center py-4">
                No available missions. Create a new mission!
              </p>
            ) : (
              <div className="space-y-2">
                 {availableMissions.map((mission) => (
                  <Button
                    key={mission.id}
                    variant="outline"
                    className="w-full justify-start gap-3 h-auto p-4 rounded-lg"
                    onClick={() => handleSelectMission(mission.id)}
                  >
                    <div className="flex-1 text-left">
                      <div className="font-medium">{mission.name}</div>
                    </div>
                    <div className="text-sm text-muted-foreground">
                      {mission.completedTodos}/{mission.requiredTodos}
                    </div>
                    <Badge variant={mission.isCompleted ? "default" : "secondary"}>
                      {mission.size}
                    </Badge>
                  </Button>
                ))}
              </div>
            );
          })()}
          
          {missions.filter(mission => !mission.isCompleted).length > 0 && (
            <div className="flex items-center py-2">
              <Separator className="flex-1" />
              <span className="px-3 text-sm text-muted-foreground">or</span>
              <Separator className="flex-1" />
            </div>
          )}
          
          <div className="space-y-2">
            <Button
              onClick={handleCreateNew}
              className="w-full gap-2"
            >
              <Plus size={16} />
              Create New Mission
            </Button>
            <Button
              variant="ghost"
              onClick={onClose}
              className="w-full"
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MissionSelectionModal;